import {
  Directive,
  ElementRef,
  Input,
  AfterViewInit,
  Renderer2,
  PLATFORM_ID,
  Inject
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: '[imgAssestsLazyLoad]'
})
export class ImgAssestsLazyLoadDirective implements AfterViewInit {
  @Input() dataSrc!: string;

  constructor(
    private el: ElementRef<HTMLImageElement>,
    private renderer: Renderer2,
    // tslint:disable-next-line:ban-types
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const img: HTMLImageElement = this.el.nativeElement;


    const observer = new IntersectionObserver((entries: IntersectionObserverEntry[]): void => {
      entries.forEach((entry: IntersectionObserverEntry): void => {
        if (entry.isIntersecting) {
          this.renderer.setAttribute(img, 'src', this.dataSrc);
          observer.unobserve(img);
        }
      });
    });

    observer.observe(img);
  }
}
